import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { calendarDateIcon, clockIcon, injectBxIcons } from '@beyonnex/bx-angular-ui';
import { formatDateTime } from '../../../models/core.models';
import { CommonTranslateService } from '../../../services/common-translate/common-translate.service';
import { CurrentStatePanelComponent } from '../current-state-panel/current-state-panel.component';
import { CurrentStateDataPoint } from '../current-state-panel/current-state-panel.models';
import { DeviceDetailsStore } from '../device-details.store';

@Component({
  selector: 'bxi-submetering-gateway-current-state',
  imports: [CurrentStatePanelComponent],
  templateUrl: './submetering-gateway-current-state.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubmeteringGatewayCurrentStateComponent {
  private readonly store = inject(DeviceDetailsStore);
  protected readonly commonTranslate = inject(CommonTranslateService);

  protected readonly gateway = toSignal(this.store.submeteringGateway$);

  // A missing value blanks its own column and never drops it, so the panel keeps the same shape on every gateway.
  protected readonly data = computed<CurrentStateDataPoint[]>(() => {
    const gateway = this.gateway();

    return [
      {
        label: this.commonTranslate.translateThingProperty('features.readout.properties.lastTransmission'),
        value: formatDateTime(gateway?.features?.readout?.properties?.lastTransmission),
        icon: 'clock',
        iconStyle: 'text-utility-blue-light-600',
      },
      {
        label: this.commonTranslate.translateThingProperty('attributes.qsmp.readoutTimes.schedules'),
        value: (gateway?.getReadoutDays() ?? []).join(', '),
        icon: 'calendar-date',
        iconStyle: 'text-utility-fuchsia-500',
      },
    ];
  });

  constructor() {
    injectBxIcons([calendarDateIcon, clockIcon]);
  }
}
